<template>
  <div v-if="term" class="term-detail">
    <div class="term-detail__container">
      <h3>{{ term.title }}</h3>
      <div v-if="historyDates && historyDates.length > 1" class="histories">
        <select
          v-model="selectedDate"
          @change="selectTermVersion"
        >
          <option
            v-for="(date, index) in historyDates"
            :key="index"
            :value="date"
          >
            {{ date }}
          </option>
        </select>
      </div>
      <div class="term-detail__content" v-if="term.terms_contents.content" v-html="term.terms_contents.content"></div>
      <img class="img" v-else-if="term.image" :src="term.image" />
    </div>
  </div>
</template>
<script>
import termsApi from '@/api/now/termsApi'
export default {
  props: {
    code: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      term: null,
      historyDates: null,
      selectedDate: null
    }
  },
  async created() {
    this.$store.commit('ui/headerTitle', '약관 보기')
    const { data } = await termsApi.getTerm(this.code)
    this.historyDates = data.history
    this.selectedDate = data.terms_contents.enforced_at
    this.term = data
  },
  methods: {
    async selectTermVersion() {
      const { data } = await termsApi.getTerm(this.code, { date: this.selectedDate })
      this.term = data
    }
  }
}
</script>
<style lang="scss" scoped>
.term-detail {
  &__container {
    padding: 0 20px 50px;
    margin: 0 auto;

    .img {
      width: 100%;
    }

    h3 {
      text-align: center;
      margin-bottom: 15px;
    }

    &::v-deep {
      ul, ol {
        padding: 5px 20px;
      }
      h1, h2, h3, h4, h5, h6 {
        text-align: center;
      }
      div.term-detail__content {
        font-family: NanumSquare, sans-serif;
        p, span, table {
          line-height: 2rem;
        }
        table {
          margin: 5px 0;
        }
      }
    }

    .histories {
      text-align: right;
      select {
        margin: 15px auto;
        padding-left: 10px;
        min-width: 160px;
        border-radius: 4px;
        border: solid 1px #d7e1ea;
        background-color: white;
        color: #66717f;
        font-size: 16px;
        font-weight: 700;
        height: 42px;
        text-align: center;
        text-align-last: center;
        -moz-text-align-last: center;
        -webkit-appearance: none;
        -moz-appearance: none;
        text-indent: 1px;
        background: url("../../assets/images/btn-input-down.svg") no-repeat;
        background-position: center right;
        padding-right: 11%;

        option:checked {
          font-weight: 600;
        }
      }
    }
    // @media screen and  {
    // }
  }
}
</style>
